import { z } from 'zod'

export const BelongLocation = z.enum(['HAND', 'BACKPACK'])
export type BelongLocation = z.infer<typeof BelongLocation>
